import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { SandhillsSlickSlider, Panel } from '@Components/Shared/SandhillsSlickSlider';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import ConditionalWrapper from '@Components/Utilities/ConditionalWrapper';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';


const PremiumLinks = (props) => {

    const windowSize = useWindowSize();
    const currentSite = useRecoilValue(atoms.currentWebsite);

    return (props && props.Cards &&
        (!windowSize.isMobile && props.Cards.length > 2) ?
        <SandhillsSlickSlider ShowSection {...props} SlidesToShow={2}>
            {props.Cards.map(card =>
                <Panel key={`site-slider-${card.Url}`} PanelType={props.ChildComponent} PanelClass={props.PanelClass} {...card} ShowExternalIcon={true} />)}
        </SandhillsSlickSlider> :
        <section className='premium-links-section'>
            <h2 className='section-title'>
                <span className='section-title-text'>{props.Title}</span>
            </h2>
            <div className='premium-links-container'>
                {props.Cards.map(site =>
                    <a key={`site-${site.Url}`} href={site.Url} aria-label={site.Name + " (" + translator.translate('sandhills.opensinanewtab') + ")"} className={'premium-link' + ((windowSize.isMobile || site.Bordered) ? ' bordered' : '')} target='_blank'>
                        <div className='content'>
                            <div className='image-wrapper'>
                                <LazyLoadImage className='listing-image' src={site.ImgUrl} alt="" />
                            </div>
                            <h3>
                                <div className='view-listing-details-link des-view-listingDetails'>
                                    <strong dangerouslySetInnerHTML={{ __html: site.Text }}></strong>
                                    <span className='show-icon'>
                                        <i className="fa-solid fa-up-right-from-square"></i>
                                    </span>
                                </div>
                            </h3>
                        </div>
                    </a>)}
            </div>
        </section>
    );
};

export default PremiumLinks;